// {feed}/archive/index.json (§14.5): índice do replay por seq, só da época vigente.
import * as z from 'zod/mini';
import { type FeedHeader, feedHeaderShape, IntSchema, type Iso, IsoSchema } from './base';

export interface ArchiveIndex extends FeedHeader<'results.archive_index'> {
  /** Ordenado por seq; só a época vigente. */
  items: Array<{
    seq: number;
    epoch: number;
    tse_ht: Iso;
    published_at: Iso;
    /** tMin(tse_ht). O seq sem tse_ht nacional (pré-abertura e antes do 1º arquivo de BR) fica fora do índice e do history (P-14). */
    t_min: number;
    /** "s/{seq}/snapshot.json" */
    path: string;
    /** "s/{seq'}/municipal.json" */
    municipal: string | null;
    probability_detail: string | null;
  }>;
}

export const ArchiveIndexSchema = z.object({
  ...feedHeaderShape('results.archive_index'),
  items: z.array(
    z.object({
      seq: IntSchema,
      epoch: IntSchema,
      tse_ht: IsoSchema,
      published_at: IsoSchema,
      t_min: z.number(),
      path: z.string(),
      municipal: z.nullable(z.string()),
      probability_detail: z.nullable(z.string()),
    }),
  ),
});
